module.exports = __webpack_public_path__ + "static/dreamstime_m_33792412-6a91b555d8fec1a1c37630f27dbceb00.jpg";